export default {
  KPIR: 1,
  RYCZALT: 2,
  KH: 3,
};
